import { useEffect, useState } from 'react';

export default function useTimer() {
  const [time, setTime] = useState(60);

  useEffect(() => {
    if (!time) return;

    const intervalId = setInterval(() => {
      setTime(time - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [time]);
  return [time, setTime];
}
